export default "__VITE_ASSET__Xoc0nZR$__"